import './styles/app.scss';
import './data/index.mockapi';
import {routes, navigation} from './routes';
import config from './config';

const appId = config.platformManagement.appId;

const application = {
  id: appId,
  name: `${appId}:applicationName`,
  routes,
  navigation,
};

export default application;
